<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="order"
            :expand="expand"
            item-key="ID"
            :must-sort="true"
            sort-icon="mdi-menu-down"
            class="prize_order-table"
            hide-actions
            :pagination.sync="pagination"
            :disable-initial-sort="true"
        >
            <template v-slot:items="props">
                <tr>
                    <td :class="!props.expanded ? 'prize_order--plus':'prize_order--minus'" @click="props.expanded = !props.expanded; get_order_detail(props.item.ID);"><img class="prize_order-icon" :src="!props.expanded ? 'icons/prize_order/add-circle.svg' : 'icons/prize_order/remove-circle.svg'" alt=""> {{ props.item.ID }}</td>
                    <td class="text-xs">{{ props.item.DATE_INSERT.substr(0, 10) }}</td>
                    <td class="text-xs">{{ props.item.PRiCE }}</td>
                    <td class="text-xs">{{ props.item.ADDRESS.FULL_ADDRESS }}</td>
                    <td class="text-xs">
                        <svg v-svg
                             v-if="props.item.STATUS_ID === 'CA'"
                             symbol="status_order-cancel"
                             size="16"
                             class="icon"
                             role="presentation"
                             style="margin: -3px 5px"
                        />
                        <svg v-svg
                             v-else-if="props.item.STATUS_ID === 'V'"
                             symbol="status_order-complete"
                             size="16"
                             class="icon"
                             role="presentation"
                             style="margin: -3px 5px"
                        />
                        <svg v-svg
                             v-else-if="props.item.STATUS_ID !=='V' && props.item.STATUS_ID !== 'CA'"
                             symbol="status_order-all"
                             size="16"
                             class="icon"
                             role="presentation"
                             style="margin: -3px 5px"
                        />
                        {{ props.item.STATUS_NAME === 'Черновик' ? 'Текущая корзина' : props.item.STATUS_NAME }}
                    </td>
                    <td class="text-xs prize_order-button"> <div v-if="props.item.STATUS_ID === 'DF' || props.item.STATUS_ID === 'F'" @click="cancel_order(props.item.ID)">Отменить заказ</div></td>
                </tr>
            </template>
            <template v-slot:expand="props">
                <v-data-table
                    :headers="detailHeaders"
                    :items="detailOrder.PRODUCTS"
                    class="prize_order-table-detail"
                    hide-actions
                >
                    <template v-slot:items="props">
                        <td class="custom-column"><img class="prize_order-img" :src="props.item.PREVIEW_PICTURE" alt=""> {{ props.item.PRODUCT_NAME }}</td>
                        <td class="text-xs">{{ props.item.SIZE }}</td>
                        <td class="text-xs">{{ props.item.QUANTITY }}</td>
                        <td class="text-xs">{{ props.item.FINAL_PRICE }}</td>
                    </template>
                    <template v-slot:no-data>
                        <div class="table-no-item" :value="true">
                            В корзине ничего нет
                        </div>
                    </template>
                </v-data-table>
            </template>
            <template v-slot:no-data>
                <div class="table-no-item" :value="true">
                    У вас еще нет совершенных заказов
                </div>
            </template>
        </v-data-table>
        <div v-if="pages > 1" class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages" />
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
  data() {
    return {
      pagination   : {},
      expand       : false,
      detailHeaders: [
        {
          text    : 'Призы',
          value   : 'PRODUCTS',
          sortable: false,
        },
        {text: 'Размер', value: 'PRODUCTS.SIZE', sortable: false},
        {text: 'Кол-во, шт', value: 'PRODUCTS.QUANTITY', sortable: false},
        {text: 'Стоимость, баллы', value: 'PRODUCTS.FINAL_PRICE', sortable: false},
      ],
      headers: [
        {
          text : 'Номер заказа',
          align: 'left',
          value: 'ID',
        },
        {text: 'Дата заказа', value: 'DATE_INSERT'},
        {text: 'Стоимость заказа', value: 'PRiCE'},
        {text: 'Адрес доставки', value: 'adres'},
        {text: 'Статус заказа', value: 'status'},
        {text: '', sortable: false},
      ],
    };
  },
  methods: {
    ...mapActions('order/OrderDetail', ['get_order_detail', 'cancel_order', 'get_order']),
    ...mapActions('order/Basket', ['delete_all']),
    loadStatus(id) {
      this.SET_STATUS(id);
    },
  },
  beforeMount() {
    this.get_order();
  },
  computed: {
    ...mapGetters('order/OrderDetail', ['order']),
    ...mapGetters('order/OrderDetail', ['detailOrder']),
    pages() {
      this.pagination.totalItems = this.order.length;
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null
      ) return 0;
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },
  },
};
</script>

<style lang="sass" scoped>

.prize_order-table table.v-datatable.v-table.theme--light thead
  background: #F3F3F3

.prize_order

  &-icon
    margin-right: 5px

  &-img
    margin: 0 20px 0 0
    height: 113px

  &-button
    color: #E4183E
    font-size: 14px
    font-weight: 400
    cursor: pointer
    transition: opacity 0.3s ease-in-out
    opacity: 1
    &:hover
      opacity: 0.75
</style>
